export default __webpack_public_path__ + "static/grub-fd5ce5bb2b279fadb619c59ccfa27cc9.webp";